import React, { useState } from 'react';
import axios from 'axios';
import config from '../config';
import { headers } from "../token";
import Swal from 'sweetalert2';
import { Link, useNavigate } from 'react-router-dom';
import validateError from '../ValidateError';
const server_backend = config.API_URL;



const ChangePassword = () => {
    const [formData, setFormData] = useState({
        current: '',
        password: '',
        password_confirm: ''
    });
    const navigate = useNavigate();

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const validateForm = () => {
        let isValid = true;
        let errors = {};

        if (!formData.current) {
            errors.current = 'Current password is required';
            isValid = false;
        }

        if (!formData.password) {
            errors.password = 'New password is required';
            isValid = false;
        } else if (formData.password.length < 6) {
            errors.password = 'New password must be at least 6 characters long';
            isValid = false;
        }

        if (formData.password !== formData.password_confirm) {
            errors.password_confirm = 'Passwords do not match';
            isValid = false;
        }

        setErrors(errors);
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let response;
        if (validateForm()) {
            try {
                response = await axios.post(`${server_backend}/users/password_reset`, formData, headers);

                if (response.data.RES_CODE === "00") {
                    setFormData({
                        current: '',
                        password: '',
                        password_confirm: ''
                    })
                    Swal.fire({
                        icon: 'success',
                        title: 'Updated Successfully',
                        showConfirmButton: false,
                        timer: 2000
                    });
                    navigate('/profiles')

                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ans unexpecteds error has occurred, make sure all fields are filled out',
                        showConfirmButton: false,
                        timer: 2000
                    });
                }
            } catch (error) {
                console.log("Unexpected error, please check")
                const message = validateError(error);

                Swal.fire({
                    icon: 'error',
                    title: message,
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        }
    };

    return (
        <div className="page-content">
            <div className="container-fluid">

                <form onSubmit={handleSubmit}>
                    <div className="card mb-3">
                        <div className="card-header">
                            <center><h5>Change Password</h5></center>
                        </div>
                        <div className="card-body">
                            <div className="mb-3">
                                <label htmlFor="current" className="form-label">Current Password</label>
                                <span className="text-danger" style={{fontSize: "20px", marginLeft: "5px"}}>*</span>
                                <input
                                    type="password"
                                    className={`form-control ${errors.current ? 'is-invalid' : ''}`}
                                    id="current"
                                    name="current"
                                    value={formData.current}
                                    onChange={handleChange}
                                    placeholder="Enter your current password"
                                />
                                {errors.current && <div className="invalid-feedback">{errors.current}</div>}
                            </div>
                            <div className="mb-3">
                                <label htmlFor="password" className="form-label">New Password</label>
                                <span className="text-danger" style={{fontSize: "20px", marginLeft: "5px"}}>*</span>
                                <input
                                    type="password"
                                    className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                    id="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    placeholder="Enter your new password"
                                />
                                {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                            </div>
                            <div className="mb-3">
                                <label htmlFor="password_confirm" className="form-label">Confirm New Password</label>
                                <span className="text-danger" style={{fontSize: "20px", marginLeft: "5px"}}>*</span>
                                <input
                                    type="password"
                                    className={`form-control ${errors.password_confirm ? 'is-invalid' : ''}`}
                                    id="password_confirm"
                                    name="password_confirm"
                                    value={formData.password_confirm}
                                    onChange={handleChange}
                                    placeholder="Confirm your new password"
                                />
                                {errors.password_confirm && <div className="invalid-feedback">{errors.password_confirm}</div>}
                            </div>
                            <Link className="btn btn-danger" to="/dashboard" style={{ marginRight: "5px" }}>Discard changes</Link>
                            <button type="submit" className="btn btn-primary">Change Password</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ChangePassword;
